((Drupal, once) => {

  Drupal.behaviors.productSliderV1 = {
    attach (context) {
      once('product-slider-v1', '.js_product_slider_v1', context).forEach((slider) => {
        initProductSliderV1(slider)
      })
    }
  }

  function initProductSliderV1(slider) {
    const sliderWrapEl = slider.closest('.product-slider-sec')
    if (!sliderWrapEl) return
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')
    const slideCount = slider.querySelectorAll('.swiper-slide').length

    let sliderOptions = {
      spaceBetween: 40,
      slidesPerView: 1,
      grabCursor: true,
      centeredSlides: slideCount < 2 ? false : true,
      noSwipingClass: 'slide-card__action-link',
      watchSlidesProgress: true,
      // No loop: Swiper clones slides, duplicating headings/links/images in the DOM.
      // rewind returns to the first slide instead, so each item is rendered once.
      loop: false,
      rewind: slideCount >= 2,
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          slidesPerView: slideCount < 2 ? slideCount : 2,
          loop: false,
          rewind: slideCount > 2,
          centeredSlides: false,
          spaceBetween: 40
        },
        // when window width is >= 992px
        991: {
          slidesPerView: slideCount <= 3 ? slideCount : 3,
          spaceBetween: 60,
          loop: false,
          rewind: slideCount > 3,
          centeredSlides: false
        }
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: false,
      },
      navigation: {
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrev,
      },
    }

    const swiperInstance = new Swiper(slider, sliderOptions)


    // Track interaction state
    let hasInteracted = false

    // Stop autoplay initially
    if (swiperInstance.autoplay) {
      swiperInstance.autoplay.stop()
    }

    // Listen for actual user interactions (not autoplay)
    swiperInstance.on('touchStart', () => {
      hasInteracted = true
    })

    swiperInstance.on('click', () => {
      hasInteracted = true
    })

    // Start autoplay when slider comes into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Only start autoplay if user hasn't interacted yet
          if (!hasInteracted && swiperInstance.autoplay) {
            swiperInstance.autoplay.start()
          }
        } else {
          if (swiperInstance.autoplay) {
            swiperInstance.autoplay.stop()
          }
        }
      })
    }, {
      threshold: 0.3 // Trigger when 30% of slider is visible
    })

    observer.observe(slider)
  }

})(Drupal, once)
